import { cloneDeep } from "lodash";

const mergeProfileFields = (target = {}, source = {}, replaceFields = []) => {
  const result =
    target && typeof target === "object" && !Array.isArray(target)
      ? { ...target }
      : {};

  for (const [key, value] of Object.entries(source)) {
    if (
      replaceFields.includes(key) ||
      value === null ||
      typeof value !== "object" ||
      Array.isArray(value)
    ) {
      result[key] = cloneDeep(value);
      continue;
    }

    result[key] = mergeProfileFields(result[key], value, replaceFields);
  }

  return result;
};

export const mergeEditableProfile = (
  profileInfo,
  updatedFields = {},
  replaceFields = [],
) => {
  if (!profileInfo) return profileInfo;

  const { demographics, ...profileFields } = updatedFields ?? {};
  return {
    ...profileInfo,
    profile: mergeProfileFields(
      profileInfo.profile,
      profileFields,
      replaceFields,
    ),
    demographics: mergeProfileFields(
      profileInfo.demographics,
      demographics,
      replaceFields,
    ),
  };
};
